import { FC, HTMLAttributes } from "react";

import { ManscapedLogo, ThemeUIStyleObject } from "@ms/gatsby-theme";

interface LogoProps extends HTMLAttributes<HTMLOrSVGElement> {
  /** Theme UI sx pragma */
  sx?: ThemeUIStyleObject;
  className?: string;
}

export const Logo: FC<LogoProps> = ({ sx, className }) => {
  return (
    <ManscapedLogo
      // Adding className to get sx props passed correctly to Logo
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      className={className}
      sx={{
        color: "white",
        ...sx,
      }}
    />
  );
};
